import { render } from "./RulesView.vue?vue&type=template&id=ab73df48"
import script from "./RulesView.vue?vue&type=script&lang=js"
export * from "./RulesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__